const project = process.env.VUE_APP_ACTOR

export function buildNavMenus({ $p, clientId }) {
  const menus = [
    {
      icon: 'home',
      text: 'menu.home[0]',
      bindAttrs: { to: '/' },
      title: 'menu.home[1]'
    },
    {
      icon: 'vps-home',
      text: 'menu.my_services[0]',
      title: 'menu.my_services[1]',
      bindAttrs: {
        group: /^\/(applications|myvps|gpu-servers|dedicated-servers|ssl|k8s-servers|domain)/
      },
      menus: [
        {
          text: 'menu.apps[0]',
          countType: 'APP',
          path: '/applications',
          title: 'menu.apps[1]',
          permission: ['menu.apps']
        },
        {
          text: 'menu.vps[0]',
          countType: 'VM',
          path: '/myvps',
          title: 'menu.vps[1]',
          permission: ['menu.vps']
        },
        {
          text: 'menu.gpu[0]',
          countType: 'GPU',
          path: '/gpu-servers',
          title: 'menu.gpu[1]',
          permission: ['menu.gpu']
        },
        {
          text: 'menu.dedicated[0]',
          countType: 'Bare Metal',
          path: '/dedicated-servers',
          title: 'menu.dedicated[1]',
          permission: ['menu.dedicated']
        },
        {
          icon: 'other',
          text: 'menu.services[0]',
          title: 'menu.services[1]',
          bindAttrs: {
            group: /^\/(ssl|k8s-servers|domain)/
          },
          menus: [
            {
              text: 'menu.ssl[0]',
              countType: 'SSL',
              path: '/ssl',
              title: 'menu.ssl[1]',
              permission: ['menu.ssl']
            },
            {
              text: 'menu.domain[0]',
              countType: 'Domain',
              path: '/domain',
              title: 'menu.domain[1]',
              permission: ['menu.domain']
            },
            {
              text: 'menu.k8s[0]',
              countType: 'Custom',
              path: '/k8s-servers',
              title: 'menu.k8s[1]',
              permission: ['menu.k8s']
            }
          ]
        }
      ]
    },
    {
      icon: 'apps',
      text: 'menu.app_market[0]',
      bindAttrs: {
        to: '/app-marketplace'
      },
      title: 'menu.app_market[1]',
      permission: ['menu.market'],
      // 游客也需要从侧边栏进入公开的软件应用列表
      noToken: true
    },

    {
      icon: 'support',
      text: 'menu.tickets[0]',
      countType: 'ticket',
      bindAttrs: {
        to: '/ticket'
      },
      title: 'menu.tickets[1]'
    },

    {
      icon: 'wallet',
      text: 'menu.billing[0]',
      bindAttrs: {
        group: /^\/(billing|affiliate)/
      },
      title: 'menu.billing[1]',
      menus: [
        { text: 'menu.billing_invoices[0]', path: `/billing/invoices` },
        {
          text: 'menu.billing_payment[0]',
          path: `/billing/paymentmethod`,
          permission: ['menu.billing.payment']
        },
        { text: 'menu.billing_credits[0]', path: `/billing/credits` },
        {
          text: 'menu.affiliate[0]',
          path: '/affiliate',
          permission: ['menu.affiliate']
        }
      ]
    },
    {
      icon: 'account',
      text: 'menu.account[0]',
      bindAttrs: {
        group: '/account'
      },
      title: 'menu.account[1]',
      menus: [
        { text: 'menu.account[1]', path: `/account/information` },
        { text: 'menu.password[0]', path: `/account/password` },
        { text: 'menu.notification[0]', path: `/account/notification` }
      ]
    },
    {
      icon: 'toolbox',
      text: 'menu.customer_tools[0]',
      title: 'menu.customer_tools[1]',
      bindAttrs: {
        group: '/dns'
      },
      menus: [
        {
          text: 'menu.dns[0]',
          path: '/dns',
          title: 'menu.dns[1]',
          permission: ['menu.dns']
        }
      ]
    },

    {
      icon: 'doc',
      text: 'menu.doc[0]',
      bindAttrs: (function () {
        if (project === 'hwy') {
          return {
            href: 'https://www.cloud-clusters.com/doc/get-started/overview',
            target: '_blank'
          }
        } else if (project === 'dbm') {
          return {
            href: 'https://www.databasemart.com/doc/get-started/overview',
            target: '_blank'
          }
        } else {
          return {
            to: '/document'
          }
        }
      })(),
      title: 'menu.doc[1]',
      noToken: true
    }
  ]

  const filterByPermission = (list) => {
    return list.filter((o) => {
      if (o.menus) {
        o.menus = filterByPermission(o.menus)
        if (!o.menus.length) return false
      }
      return o.permission ? $p(o.permission) : o.show === undefined || o.show === true
    })
  }
  const arr = filterByPermission(menus)
  return arr.filter((o) => {
    return clientId === -1 || !clientId ? o.noToken : true
  })
}

export function getNodeTarget(node) {
  if (node.path) return node.path
  if (node.bindAttrs && node.bindAttrs.to) return node.bindAttrs.to
  return undefined
}

export function findMenuChain(tree, targetPath) {
  const dfs = (nodes, trail) => {
    for (const node of nodes) {
      const nextTrail = trail.concat(node)
      if (getNodeTarget(node) === targetPath) {
        return nextTrail
      }
      if (node.menus && node.menus.length) {
        const found = dfs(node.menus, nextTrail)
        if (found) return found
      }
    }
    return null
  }
  return dfs(tree, [])
}
